<template>
  <!-- 充放电看板 bulletinBoard-->
  <div class="bulletinBoard" :id="idFlag?'kanban':''">
    <div class="icons">
      <img src="@/page/projectDingZhi/yuenan/params/22.png" v-if="fullscreen" @click="handleFullScreen">
      <img src="@/page/projectDingZhi/yuenan/params/11.png" v-else @click="handleFullScreen">
      <img src="@/page/projectDingZhi/yuenan/params/home.png" @click="idFlag = !idFlag">
    </div>
    <div class="span" style="display: flex;margin-bottom: 10px;">
      <div class="box" style="height: 28%;margin-right: 10px;">
        <div class="tit">近一年累计净收益(元)</div>
        <div class="icon_box">
          <div class="li">
            <img class="img" src="../../assets/bulletinBoard/1.png">
            <div class="num">{{shouyi.jinshouye}}</div>
            <div class="name">净收益</div>
          </div>
          <div class="li">
            <img class="img" src="../../assets/bulletinBoard/2.png">
            <div class="num" style="color: #368ed9;">{{shouyi.chongdian}}</div>
            <div class="name">充电成本</div>
          </div>
          <div class="li">
            <img class="img" src="../../assets/bulletinBoard/3.png">
            <div class="num" style="color: #25b0a8;">{{shouyi.fangdian}}</div>
            <div class="name">放电收益</div>
          </div>
        </div>
      </div>
      <div class="box" style="padding-top:13px;flex: 1;">
        <div class="tit">基本情况</div>

        <div class="all_box">
          <div class="text_box">
            <div class="li">
              <div class="name">电站额定功率</div>
              <div class="num">{{base[0]}}</div>
              <div class="unit">KW</div>
            </div>
            <div class="li">
              <div class="name">电池族总功率</div>
              <div class="num">{{base[1]}}</div>
              <div class="unit">KW</div>
            </div>
            <div class="li">
              <div class="name">系统总容量</div>
              <div class="num">{{base[2]}}</div>
              <div class="unit">KW</div>
            </div>
          </div>
          <div class="text_box">

            <div class="li">
              <div class="name">当前可充容量</div>
              <div class="num">{{base[3]}}</div>
              <div class="unit">KWh</div>
            </div>
            <div class="li">
              <div class="name">当前可放容量</div>
              <div class="num">{{base[4]}}</div>
              <div class="unit">KWh</div>
            </div>
            <div class="li">
              <div class="name">电站储能PCS运行</div>
              <div class="num">{{base[5]}}</div>
              <div class="unit">台</div>
            </div>

          </div>
          <div class="text_box">
            <div class="li">
              <div class="name">日充电量</div>
              <div class="num">{{base[6]}}</div>
              <div class="unit">KWh</div>
            </div>
            <div class="li">
              <div class="name">日放电量</div>
              <div class="num">{{base[7]}}</div>
              <div class="unit">KWh</div>
            </div>
            <div class="li">
              <div class="name">电池簇SOH</div>
              <div class="num">{{base[8]}}</div>
              <div class="unit">%</div>
            </div>


          </div>
        </div>
      </div>
    </div>
    <div class="span" style="display: flex;margin-bottom: 10px;height: 30%">
      <div class="box" ref="boxed" style="height: 100%;margin-right: 10px;">
        <div class="tit">运行总览</div>
        <!-- <div class="infos">已安全运行 360 天</div> -->
        <div class="zonglan">
          <div class="li">
            <div class="img">
              <img src="../../assets/bulletinBoard/4.png" alt="">
              <div class="n">PCS运行台数</div>
            </div>
            <div class="num">{{Overview[0]}}</div>
            <div class="uni">台</div>
          </div>
          <div class="li">
            <div class="img">
              <img src="../../assets/bulletinBoard/5.png" alt="">
              <div class="n">总充电量</div>
            </div>
            <div class="num">{{Overview[2]}}</div>
            <div class="uni">KWh</div>
          </div>
          <div class="li">
            <div class="img">
              <img src="../../assets/bulletinBoard/6.png" alt="">
              <div class="n">总SOC</div>
            </div>
            <div class="num">{{Overview[1]}}</div>
            <div class="uni">%</div>
          </div>
          <div class="li">
            <div class="img">
              <img src="../../assets/bulletinBoard/7.png" alt="">
              <div class="n">总放电量</div>
            </div>
            <div class="num">{{Overview[3]}}</div>
            <div class="uni">KWh</div>
          </div>
        </div>
      </div>
      <div class="box" style="flex: 1;">
        <div class="tit">总充放功率日曲线</div>
        <div class="titles">
          <!-- <div class="p">总充放电功率 <div class="span">{{allPower}}</div>KWh</div> -->
        </div>
        <vchart class="vcharted" :style="{'height':heighted}" ref='vchart1'></vchart>
      </div>
    </div>
    <div class="box" style="height: 44% ;width: 100%;">
      <div class="tit">近一年累计收益分析</div>
      <vchart class="vcharted" ref='vchart2'></vchart>
    </div>
  </div>
</template>

<script>
  import vchart from '@/components/module/chart/vchart.vue'
  import request from "@/api/http.js";
  export default {
    components: {
      vchart
    },
    data () {
      return {
        heighted: '200px',
        Overview: {},//运行总览
        base: { //基本情况
          "0": "1500KW",
          "3": 17.11,
          "4": 17.11,
          "5": 17.11,
          "6": 17.11,
          "7": "1",
          "8": 17.11,
          "9": 17.11,
          "10": 17.11
        },
        shouyi: {
          jinshouye: 0,//净收益
          chongdian: 0,//充电
          fangdian: 0,//放电
        },//收益
        fullscreen: false,
        idFlag: false,
        option: {
          tooltip: {
            trigger: 'axis',
          },
          xAxis: {
            type: 'category',
            data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月',],
            splitLine: {
              show: false,
              lineStyle: {
                color: 'rgba(0, 240, 255, 0.3)'
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 14
              }
            }
          },
          yAxis: {
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed'
              }
            },
            //文字
            axisLabel: {
              color: '#fff'
            }
          },
          legend: {
            textStyle: {
              fontSize: 16,//字体大小
              color: '#ccc'//字体颜色
            },
            top: 23,
            right: 25,
            icon: "circle",   //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 10,  // 设置宽度 
            itemHeight: 10, // 设置高度
          },
          grid: {
            top: 70,
            bottom: '5%',
            left: '2%',
            right: '3%',
            containLabel: true
          },
          color: ['#368ED9','#25B0A8','#d6c339'], //柱子颜色

          series: [
            {
              name: '充电成本',
              data: [4.1,3.9,4.3,4.5,4.1,4.2,3.5],
              type: 'bar',
              smooth: true
            },
            {
              name: '放电收益',
              data: [18.2,17.3,20.4,24.7,13.9,12.7,19.37],
              type: 'bar',
              smooth: true
            },{
              name: '净收益',
              data: [13.4,12.5,17.3,22.6,14.2,10.9,7.07],
              type: 'bar',
              smooth: true
            },
          ]

        },
        quxian: {
          0: [215],
          1: [102.3,112.7],
          2: [61.5,70.9,82.6],
          3: [68.35,49.1,53.9,43.65],
          4: [38.2,42.7,45.6,53.8,34.7],
          5: [35.2,26.7,30.9,40.5,45.6,36.1],
          6: [30.7,25.5,36.7,40.8,35.5,28.9,39.9],
          7: [26.8,30.7,26.4,25.7,32.6,19.8,30.1,22.9],
          8: [16.7,20.2,23.9,28.3,18.4,22.2,24.7,28.2,32.4],
          9: [21.5,25.7,18.5,14.9,20.8,24.6,20,16.7,26.7,26.2],
          10: [19.5,22.7,25.6,20.1,18.6,20.8,15.3,12.8,18.6,20.9,20.1],
          11: [17.9,20.6,18.7,20.5,19.3,15.4,16.8,16.9,22.1,17.4,15.9,14.5],
          12: [16.5,17.5,15.8,18.6,13.4,20.1,12.7,14.6,11.8,16.1,18.4,13.4,26.1],
          13: [15.3,18.6,12.4,17.6,12.8,13.4,18.1,15.3,12.6,17.6,20.1,12.6,10.4,18.2],
          14: [14.3,17.7,11.5,13.6,15.7,18.7,16.9,14.6,17.7,15.4,11.5,10.7,11.3,8.6,16.8],
          15: [13.4,11.6,15.9,11.8,16.6,13.7,11.4,15.8,10.4,14.3,13.7,10.8,16.4,9.6,12.3,17.3],
          16: [12.4,10.5,13.1,13.7,12.8,11.7,14.8,9.5,13.7,15.4,12.7,14.7,12.4,9.2,8.4,11.3,18.7],
          17: [9.4,12.6,13.5,13.3,11.5,12.9,13.7,8.6,11.5,12.4,8.2,9.5,10.7,9.5,8.5,11.9,10.7,7.6,],
          18: [11.4,10.6,13.5,13.3,11.5,12.9,13.7,8.6,11.5,12.4,8.2,9.5,10.7,9.5,8.5,11.9,10.7,7.6,14.5],
          19: [11.4,10.6,13.5,13.3,11.5,12.9,13.7,8.6,11.5,12.4,8.2,9.5,10.7,9.5,8.5,11.9,10.7,7.6,11.1,8.6],
          20: [11.4,10.6,13.5,13.3,11.5,12.9,13.7,8.6,11.5,12.4,8.2,9.5,10.7,9.5,8.5,11.9,10.7,7.6,13.2,8.6,7.6],
          21: [11.4,10.6,13.5,13.3,11.5,12.9,13.7,8.6,11.5,12.4,8.2,9.5,10.7,9.5,8.5,11.9,10.7,7.6,12.4,6.2,7.6,9.2],
          22: [11.4,10.6,13.5,13.3,11.5,12.9,13.7,8.6,11.5,12.4,8.2,9.5,10.7,9.5,8.5,11.9,10.7,7.6,10.4,6.5,8.4,9.5,8.9],
          23: [11.4,10.6,13.5,13.3,11.5,12.9,13.7,8.6,11.5,12.4,8.2,9.5,10.7,9.5,8.5,11.9,10.7,7.6,13.4,9.4,8.6,10.8,8.6,10.5],
        },
        zhuzhuang: {
          tooltip: {
            trigger: 'axis',
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: [
              "0:00",
              "01:00",
              "02:00",
              "03:00",
              "04:00",
              "05:00",
              "06:00",
              "07:00",
              "08:00",
              "09:00",
              "10:00",
              "11:00",
              "12:00",
              "13:00",
              "14:00",
              "15:00",
              "16:00",
              "17:00",
              "18:00",
              "19:00",
              "20:00",
              "21:00",
              "22:00",
              "23:00",
            ],
            splitLine: {
              show: false,
              lineStyle: {
                color: 'rgba(0, 240, 255, 0.3)'
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 14
              }
            }
          },
          yAxis: {
            type: 'value',
            boundaryGap: false,
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed'
              }
            },
            //文字
            axisLabel: {
              color: '#fff'
            }
          },
          legend: {
            textStyle: {
              fontSize: 16,//字体大小
              color: '#ccc'//字体颜色
            },
            top: 23,
            right: 25,
            icon: "circle",   //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 10,  // 设置宽度 
            itemHeight: 10, // 设置高度
          },
          grid: {
            top: 60,
            bottom: '6%',
            left: '2%',
            right: '3%',
            containLabel: true
          },
          color: ['#368ED9','#25B0A8','#cb8429'], //柱子颜色
          series: [
            {
              name: '充放电功率',
              data: [11.4,10.6,13.5,13.3,11.5,12.9,13.7,8.6,11.5,12.4,8.2,9.5,10.7,9.5,8.5,11.9,10.7,7.6,13.4,9.4,8.6,10.8,8.6,10.5],
              type: 'line',
              symbol: 'none', //去掉折线图中的节点
              smooth: true
            },

          ]
        },

      }
    },
    // 

    mounted () {

      this.heighted=(this.$refs.boxed.offsetHeight-10)+'px'
      // 基本信息
      request({url: "/stored/basicInformation",method: "get"}).then(res => {
        if(res.code==200) {
          this.base=res.data;
        }
      })
      // 运行总览
      request({url: "/stored/operationOverview",method: "get"}).then(res => {
        if(res.code==200) {
          this.Overview=res.data;
        }
      })

      this.yonghu();
      this.yonghu2();
    },
    methods: {

      // 全屏事件
      handleFullScreen () {
        // 此处可根据获取节点进行区域全屏事件

        let element=document.getElementsByClassName('bulletinBoard')[0];
        if(this.fullscreen) {
          if(document.exitFullscreen) {
            document.exitFullscreen();
          } else if(document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if(document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if(document.msExitFullscreen) {
            document.msExitFullscreen();
          }
          setTimeout(() => {
            this.heighted=(this.$refs.boxed.offsetHeight-10)+'px'
            this.$refs.vchart1.resize();
          },200);
        } else {
          this.heighted='100%'
          if(element.requestFullscreen) {
            element.requestFullscreen();
          } else if(element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if(element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if(element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen();
          }
        }
        this.fullscreen=!this.fullscreen;
      },
      // 收益分析
      yonghu2 () {
        this.$refs.vchart2.setData(this.option,true);
        this.shouyi={
          jinshouye: 0,
          chongdian: 0,
          fangdian: 0,
        }
        this.$refs.vchart2.showLoading();
        // 人民电器储能看板->收益分析
        request({url: "/stored/incomeAnalysis",method: "get"}).then(res => {
          this.$refs.vchart2.hideLoading();
          if(res.code==200) {
            this.option.series[0].data=[];
            this.option.series[1].data=[];
            this.option.series[2].data=[];
            for(const key in res.data[0]) {
              this.option.series[0].data.push(res.data[0][key])
              this.option.series[1].data.push(res.data[1][key])
              this.option.series[2].data.push(res.data[2][key])
              console.log(Number(res.data[0][key]));
              this.shouyi.chongdian+=Number(res.data[0][key])
              console.log(this.shouyi.chongdian,'this.shouyi.chongdian');
              this.shouyi.fangdian+=Number(res.data[1][key])
              this.shouyi.jinshouye+=Number(res.data[2][key])
            }

            this.shouyi.jinshouye=this.shouyi.jinshouye.toFixed(2)
            this.shouyi.chongdian=this.shouyi.chongdian.toFixed(2)
            this.shouyi.fangdian=this.shouyi.fangdian.toFixed(2)

            this.$refs.vchart2.setData(this.option,true);;
          }
        })
      },
      // 人民电器储能看板->获取看板总充放功率列表
      yonghu () {

        this.$refs.vchart1.showLoading();
        //获取看板总充放功率列表
        request({url: "/stored/findDayTotalPower",method: "get"}).then(res => {
          this.$refs.vchart1.hideLoading();
          // console.log(res,'获取看板总充放功率列表');
          if(res.code==200&&res.data) {


            this.zhuzhuang.series[0].data=res.data;
            this.$refs.vchart1.setData(this.zhuzhuang,true);
          }
        })
        this.$refs.vchart1.setData(this.zhuzhuang,true);
      },
    }
  };
</script>

<style lang="scss" scoped>
  #kanban {
    width: 100%;
    position: fixed;
    top: 0;
    margin: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100% !important;
    z-index: 10;
  }

  .icons {
    position: absolute;
    right: 10px;
    top: 24px;
    z-index: 11;
  }

  .icons img {
    margin-left: 15px;
  }

  .titles {
    position: absolute;
    top: 20px;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    color: #fff;
    z-index: 10;
  }

  .titles .p {
    display: flex;
    align-items: center;
    margin-right: 40px;
  }

  .titles .p .span {
    color: #368ED9;
    font-weight: bold;
    font-size: 16px;
    margin-left: 15px;
    margin-right: 5px;
  }

  .vcharted {
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9;
    max-height: 300px;
  }

  .infos {
    position: absolute;
    right: 20px;
    top: 22px;
    color: #368ED9;
    font-size: 13px;
  }

  .zonglan {
    width: 445px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
  }

  .zonglan .li .uni {
    font-size: 14px;
  }

  .zonglan .li .num {
    font-size: 24px;
    color: #368ED9;
    margin-right: 5px;
  }

  .zonglan .li .img {
    margin-right: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 88px;
  }

  .zonglan .li .img .n {
    font-size: 14px;
    width: 100%;
    text-align: center;
  }

  .zonglan .li {
    width: 50%;
    box-sizing: border-box;
    display: flex;
    color: #fff;
    align-items: center;
    padding: 0 15px;
    height: 100px;
  }

  .all_box {
    margin-top: 25px;
  }

  .all_box .text_box .li .name {
    width: 130px;
    text-align: right;
  }

  .all_box .text_box .li .num {
    text-align: center;
    color: #368ED9;
  }

  .all_box .text_box .li .unit {
    width: 85px;
  }

  .all_box .text_box .li {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .all_box .text_box {
    display: flex;
    flex-direction: column;
    width: 33%;
    border-left: 1px solid #368ED966;
  }

  .all_box .text_box:nth-child(1) {
    border-left: none;
  }

  .all_box .text_box:nth-child(1) .li .name {
    width: 100px;
  }

  .all_box .text_box:nth-child(3) .li .unit {
    width: 50px;
  }

  .all_box .text_box:nth-child(3) .li .name {
    width: 150px;
  }

  .all_box .text_box:nth-child(2) .li .name {
    width: 150px;
  }


  .all_box {
    display: flex;
  }

  .box {
    display: inline-block;
    box-sizing: border-box;
    background: rgba(129, 197, 255, 0.25);
    padding: 15px;
    padding-top: 12px;
    position: relative;
    overflow: hidden;
  }

  .box .icon_box {
    display: flex;
    margin-top: 30px;
    width: 500px;
    justify-content: space-around;
  }

  .box .icon_box .li .name {
    color: #fff;
    font-size: 14px;
  }

  .box .icon_box .li .num {
    color: #D6C339;
    font-size: 32px;
  }

  .box .icon_box .li {
    display: flex;
    flex-direction: column;
    align-items: center;

  }

  .box .tit {
    display: inline-block;
    font-size: 16px;
    border-bottom: 2px solid #368ED9;
  }

  .bulletinBoard {
    background: url('../../../public/static/image/dekan/denken.png');
    /* background-color: #304156; */
    background-size: 100% 100%;
    color: #fff;
    box-sizing: border-box;
    padding: 10px !important;
    overflow-x: hidden;
    position: relative;
  }
</style>